import React from 'react';
import moment from 'moment';

import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';

import { DATE_ONLY_MONTH_FORMAT, DATE_FORMAT } from '@share/constants';
import { formatDateCheckInOut } from '@share/utils';
import { HotelSearchArgs } from '@common-types';
import { DATE_FORMAT_ISO } from '@constants';
import {
  IAccount,
  IHotelsRecentSearches,
  IRoomResponse,
  LocationsTypes,
} from '@share/common-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faBuilding, faLocationDot, faPlane } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps {
  data: IHotelsRecentSearches;
  account: IAccount;
  disabled: boolean;
  onSearchHandler: HotelSearchArgs;
}

const ZERO = 0;

export class RecentSearches extends React.Component<IProps> {
  adultsCount = () => {
    return this.props.data?.rooms?.reduce((res: number, { adultsCount }: IRoomResponse) => {
      return res + adultsCount;
    }, ZERO);
  };

  childrenCount = () => {
    return this.props.data?.rooms?.reduce((res: number, { kidsAges }: IRoomResponse) => {
      const kidsCount = kidsAges ? kidsAges?.length : ZERO;
      return res + kidsCount;
    }, ZERO);
  };

  render(): React.ReactNode {
    const { data, disabled, account, onSearchHandler } = this.props;
    const { location, rooms } = data;
    let { checkIn, checkOut } = data;

    checkIn = moment(checkIn).format(DATE_FORMAT_ISO);
    checkOut = moment(checkOut).format(DATE_FORMAT_ISO);

    const locale = account?.locale;
    const formattedStartDate = checkIn && formatDateCheckInOut(checkIn, DATE_ONLY_MONTH_FORMAT, locale);
    const formattedEndDate = checkOut && formatDateCheckInOut(checkOut, DATE_FORMAT, locale);
    
    const generalBorderRadius = account?.generalBorderRadius ? account?.generalBorderRadius : null;
    const linksColor = account?.linksColor ? account?.linksColor : null;
    
    const stylesMain: any = !isEmpty(generalBorderRadius) ? { borderRadius: `${generalBorderRadius}px` } : {};  
    const stylesLinks: any = !isEmpty(linksColor) ? { color: linksColor } : {};  

    return (
      <div
        role="button"
        className={`search-recents-picker ${disabled ? 'disabled' : ''}`}
        onClick={() => onSearchHandler(location, checkIn, checkOut, rooms)}
        style={stylesMain}
      >
        {location.type === LocationsTypes.Destination && (<FontAwesomeIcon icon={faLocationDot} style={{ color: '#D2D2D2' }} />)}
        {location.type === LocationsTypes.Hotel && <FontAwesomeIcon icon={faBuilding} style={{ color: '#D2D2D2' }} />}
        {location.type === LocationsTypes.Airport && <FontAwesomeIcon icon={faPlane} style={{ color: '#D2D2D2' }} />}
        <div className="search-recents-picker__info">
          <p className="search-recents-picker__title">{location.name}</p>
          <p className="search-recents-picker__subtitle ttl">
            {checkIn && (
              <span>
                {formattedStartDate} - {formattedEndDate}
              </span>
            )}
          </p>
          <p className="search-recents-picker__subtitle">
            {this.adultsCount()}{' '}
            <FormattedMessage id="adult" values={{ count: this.adultsCount() }} />,{' '}
            {!!this.childrenCount() && (
              <>
                {this.childrenCount()}{' '}
                <FormattedMessage id="child" values={{ count: this.childrenCount() }} />,{' '}
              </>
            )}
            {rooms?.length} <FormattedMessage id="room" values={{ count: rooms?.length }} />
          </p>
          <div className={`search-again secondary-font ${disabled ? 'disabled' : ''}`} style={stylesLinks}>
              <FormattedMessage id="availability.status.modal.search_again" />
              <FontAwesomeIcon icon={faArrowRight} />
          </div>
        </div>
      </div>
    );
  }
}
